<template>
	<v-container grid-list-xl v-if="show">
		<v-layout
			row
			justify-center
		>
			<v-flex
				xs12
				md8
				pa-0
			>
				<NewItem
					v-if="canEdit"
					ref="newItem"
					button-title="New Custom Data"
				>
					<template slot="form">
						<CustomFieldForm
							@close="$refs.newItem.close()"
						/>
					</template>
				</NewItem>
			</v-flex>
		</v-layout>
		
		<CustomFieldsIterator
			:items="customDatas.models"
			@update="updateField"
			@delete="deleteField"
		/>	
		
		<v-dialog
			v-model="showEditDialog"
			max-width="800"
		>
			<v-card>
				<v-container grid-list-xl>
					<CustomFieldForm
						:edit-custom-field="editField"
						@close="showEditDialog = false"
					/>
				</v-container>
			</v-card>
		</v-dialog>
		
		<Confirm ref="confirm" />
	</v-container>
</template>

<script>
import CustomFieldForm from '@/components/Project/CustomFields/CustomFieldForm';
import CustomFieldsIterator from '@/components/Project/CustomFields/CustomFieldsIterator';
import NewItem from '@/components/NewItem';
import Confirm from '@/components/Confirm';

export default {
	components: {
		CustomFieldForm,
		CustomFieldsIterator,
		NewItem,
		Confirm,
	},

	data() {
		return {
			show: false,
			showEditDialog: false,
			editField: null,
		};
	},
	
	created() {
		this.show = this.project.userCan('view_custom_data');
		if (!this.show) {
			this.$router.replace({ name: 'NotFound' });
		}
	},
	
	computed: {
		project() {
			return this.$store.get('projects/currentProject');
		},
		
		customDatas() {
			return this.project.customDatas;
		},
		
		canEdit() {
			return this.project.userCan('manage_custom_data') && !this.project.isArchived;
		},
	},
	methods: {
		updateField(field) {
			this.editField = field;
			this.showEditDialog = true;
		},
		
		deleteField(field) {
			console.log('deleteField disabled');
			return;
			const name = field.label;

			this.$refs.confirm.createConfirm(`This will delete "${name}".`, 'error').then((answer) => {
				if (!answer) {
					return;
				}
				field.delete().then(() => {
					this.customDatas.forEach((f) => {
						if (!f.id) {
							const deleteIndex = this.customDatas.indexOf(f);
							this.customDatas.splice(deleteIndex, 1);
						}
					});
					this.$notify('success', `Field "${name}" has been deleted.`);
				}).catch(() => {
					this.$notify('error', `Failed to delete field "${name}".`);
				});
			});
		},
	},
};
</script>
